import { type Stacklet } from '@/entities/stacklet';
import request from '@/shared/api/request';

export const createStackletSnapshot = (
  stacklet_id: number,
  data: { name: string; action: string },
): Promise<{ stacklet: Stacklet }> =>
  request({
    url: `/stacklets/${stacklet_id}/`,
    method: 'POST',
    data,
  });
